import {onMounted, ref} from "vue";

export function useLifecycle() {
	const isMounted = ref(false);

	onMounted(() => {
		isMounted.value = true;
	});

	return {isMounted};
}
